// @flow
import React from 'react';
import styled from 'styled-components';

type LabelProps = {
  title?: string,
  subtitle?: string,
  align?: string,
};

const LabelWrapper = styled.span`
  text-align: ${props => (props.align ? props.align : 'left')};
`;

const LabelTitle = styled.span`
  color: var(--color-base-font);
  display: block;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;

  @media (min-width: 600px) {
    font-size: 18px;
  }
`;

const LabelSubtitle = styled.span`
  color: var(--color-base-font-secondary);
  display: block;
`;

export const Label = ({ title, subtitle, align }: LabelProps) => {
  return (
    <LabelWrapper align={align}>
      <LabelTitle className="labelTitle">{title}</LabelTitle>
      <LabelSubtitle className="labelSubtitle">{subtitle}</LabelSubtitle>
    </LabelWrapper>
  );
};
